export const TITLE = 'Our Value Principles';
export const PRINCIPLES = [
  {id: 0, picture: '/pages/inside/pattern-1.webp', name: 'Acceleration'},
  {id: 1, picture: '/pages/inside/pattern-2.webp', name: 'Excellence'},
  {id: 2, picture: '/pages/inside/pattern-3.webp', name: 'Passion'},
  {id: 3, picture: '/pages/inside/pattern-4.webp', name: 'Innovation'},
];
